module.exports = __webpack_public_path__ + "images/pin-bg-884b940420affae5d6038cf6f23422b1.png";